module.exports = __webpack_public_path__ + "static/media/fdi-insert.9d130c92.pdf";